// Autogenerated file
export const scenarioFlagsEnum = {
    Main: "Main",
    FixAnswersOnline: "FixAnswersOnline",
};
export const scenarioFlags = [
    { label: "Основной сценарий", value: "Main", intValue: 1 },
    { label: "Фиксировать ответы онлайн", value: "FixAnswersOnline", intValue: 2 },
];
